<template>
  <!-- 开户服务 -->
  <div class="main-container" v-if="formData && serviceInfo.id">
    <div class="info-box" v-if="serviceInfo.svcCateCode == 'BANK_ACCOUNT'">特别提示：服务经银行确认后，将无法撤销！</div>
    <div class="info-box" v-if="serviceInfo.svcCateCode == 'SHUTTLE'">特别提示：发车前24h可取消服务！</div>
    <Form ref="myForm" :model="formData" :label-width="130" class="page-form">
      <FormItem label="服务名称">
        <span>{{ serviceInfo.svcName }}</span>
      </FormItem>
      <FormItem label="兑换积分">
        <span>{{ serviceInfo.commission }}</span>
      </FormItem>
      <FormItem label="服务状态">
        <div>
          <span class="my-tag" v-if="formData.orderState == 0">待完成</span>
          <span class="my-tag blue" v-else-if="formData.orderState == 1">待审核</span>
          <span class="my-tag green" v-else-if="formData.orderState == 2">已通过</span>
          <span class="my-tag red" v-else-if="formData.orderState == 3">已驳回</span>
          <span class="my-tag org" v-else-if="formData.orderState == 4">已退回</span>
        </div>
      </FormItem>
      <!-- <FormItem label="银行经理" v-if="formData.orderState == 2">
        <span>{{ formData.detail.bankManagerName }}</span>
      </FormItem> -->
      <template v-if="formData.orderState == 2">
        <FormItem label="开户时间">
          <span>{{ formData.detail.openTime }}</span>
        </FormItem>
        <FormItem label="开户地点">
          <span>{{ formData.detail.openAddress }}</span>
        </FormItem>
        <FormItem label="对接方式">
          <span>{{ formData.detail.interfaceType }}</span>
        </FormItem>
        <FormItem label="注意事项" class="full">
          <span class="pie">{{ formData.detail.notes }}</span>
        </FormItem>
        <FormItem label="特别注意" class="full">
          <span class="pie">{{ formData.detail.specialNotes }}</span>
        </FormItem>
      </template>
      <FormItem label="驳回原因" v-if="formData.orderState == 3" class="full">
        <span class="item-value">{{ formData.remark }}</span>
      </FormItem>
      <FormItem label="退回原因" v-if="formData.orderState == 4" class="full">
        <span class="item-value">{{ formData.remark }}</span>
      </FormItem>
      <div class="form-title">基本信息</div>
      <FormItem label="客户类型" prop="cType" :rules="$units.formRule.required('请选择')" v-if="serviceInfo.svcCateCode == 'BANK_ACCOUNT'">
        <span v-if="disabled">{{ formData.rid ? '签单客户' : '非签单客户' }}</span>
        <RadioGroup v-model="formData.cType" v-else>
          <Radio label="1">签单客户</Radio>
          <Radio label="0">非签单客户</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem
        label="关联预约单编号"
        prop="reservationNo"
        :rules="$units.formRule.required('请选择')"
        v-if="formData.cType == 1 && serviceInfo.svcCateCode == 'BANK_ACCOUNT'"
      >
        <span v-if="disabled || formData.rid">{{ formData.reservationNo }}</span>
        <lzSelect
          v-else
          ref="userSelect"
          v-model="formData.reservationNo"
          placeholder="请输入预约单号或客户手机号"
          :remote-method="getOrderList"
          @change="reservationNoChange"
        >
          <template slot-scope="{ list }">
            <Option v-for="(item, i) in list" :key="i" :value="item.reservationNo" :label="`${item.reservationNo}`">
              {{ item.reservationNo }}({{ item.mobile }})
            </Option>
          </template>
        </lzSelect>
      </FormItem>

      <template v-if="$units.isSelfOrg(formData)">
        <FormItem label="客户姓名" prop="customerName" :rules="$units.formRule.required('请输入')">
          <span v-if="disabled" class="descrypt-text" @dblclick="openEye(formData, 'customerName')">{{ formData.customerName }}</span>
          <Input v-else v-model="formData.customerName" placeholder="请输入" />
          <a v-if="disabled && formData.customerName" style="position: absolute; color: #2d8cf0 !important">
            <i class="iconfont iconyincang eye-icon eye" v-if="!formData.eyeShowcustomerName" @click="openEye(formData, 'customerName')"></i>
          </a>
        </FormItem>
        <FormItem label="拼音" prop="detail.namePinyin" :rules="$units.formRule.required('请输入')" v-if="serviceInfo.svcCateCode == 'BANK_ACCOUNT'">
          <span v-if="disabled" class="descrypt-text" @dblclick="openEye(formData.detail, 'namePinyin')">{{ formData.detail.namePinyin }}</span>
          <Input v-else v-model="formData.detail.namePinyin" placeholder="请输入" />
          <a v-if="disabled && formData.detail.namePinyin" style="position: absolute; color: #2d8cf0 !important">
            <i class="iconfont iconyincang eye-icon eye" v-if="!formData.detail.eyeShownamePinyin" @click="openEye(formData.detail, 'namePinyin')"></i>
          </a>
        </FormItem>
      </template>
      <FormItem label="预计到港时间" prop="detail.expectedArriveDate" :rules="$units.formRule.required('请选择')">
        <span v-if="disabled">{{ formData.detail.expectedArriveDate | cutString(16) }}</span>
        <DatePicker
          v-else
          type="datetime"
          format="yyyy-MM-dd HH:mm"
          placeholder="选择日期"
          :editable="false"
          :value="formData.detail.expectedArriveDate"
          @on-change="$set(formData.detail, 'expectedArriveDate', $event)"
        ></DatePicker>
      </FormItem>
      <FormItem
        label="预计可开户日期"
        prop="detail.expectedBankDate"
        :rules="$units.formRule.required('请选择')"
        v-if="serviceInfo.svcCateCode == 'BANK_ACCOUNT'"
      >
        <span v-if="disabled">{{ formData.detail.expectedBankDate }}</span>
        <DatePicker
          v-else
          type="date"
          format="yyyy-MM-dd"
          placeholder="选择日期"
          :editable="false"
          :value="formData.detail.expectedBankDate"
          @on-change="$set(formData.detail, 'expectedBankDate', $event)"
        ></DatePicker>
      </FormItem>

      <template v-if="$units.isSelfOrg(formData)">
        <template v-if="serviceInfo.svcCateCode == 'SHUTTLE'">
          <div class="form-title">服务信息</div>
          <FormItem
            label="客户联系方式"
            prop="detail.mobile"
            :rules="formData.detail.mobile && formData.detail.mobile.indexOf('*') != -1 ? {} : $units.formRule.tel()"
          >
            <span v-if="disabled">{{ formData.detail.mobile }}</span>
            <Input v-else v-model="formData.detail.mobile" placeholder="请输入" />
            <a v-if="disabled && formData.detail.mobile" style="position: absolute; color: #a8adb7">
              <i class="iconfont iconyincang eye-icon eye" v-if="!formData.detail.eyeShowmobile" @click="openEye(formData.detail, 'mobile')"></i>
            </a>
          </FormItem>
          <FormItem label="坐车人数" prop="detail.passengers" :rules="$units.formRule.num('输入的类型为数字')">
            <span v-if="disabled">{{ formData.detail.passengers }}</span>
            <Input v-else v-model="formData.detail.passengers" placeholder="请输入" />
          </FormItem>
          <FormItem label="行李数量" prop="detail.bags" :rules="$units.formRule.num('输入的类型为数字')">
            <span v-if="disabled">{{ formData.detail.bags }}</span>
            <Input v-else v-model="formData.detail.bags" placeholder="请输入" />
          </FormItem>
          <FormItem label="航班号/高铁车次" prop="detail.trainNo" :rules="$units.formRule.required('请输入')">
            <span v-if="disabled">{{ formData.detail.trainNo }}</span>
            <Input v-else v-model="formData.detail.trainNo" placeholder="请输入" />
          </FormItem>
          <FormItem label="备注">
            <span v-if="disabled">{{ formData.detail.remark }}</span>
            <Input v-else v-model="formData.detail.remark" placeholder="请输入" type="textarea" :autosize="{ minRows: 2 }" />
          </FormItem>
        </template>
        <template v-if="serviceInfo.svcCateCode == 'BANK_ACCOUNT'">
          <div class="form-title">身份信息</div>
          <FormItem label="身份证号码" prop="detail.idcardNo" :rules="$units.formRule.required('请输入')">
            <span v-if="disabled" class="descrypt-text" @dblclick="openEye(formData.detail, 'idcardNo')">{{ formData.detail.idcardNo }}</span>
            <Input v-else v-model="formData.detail.idcardNo" placeholder="请输入" @on-change="idcardChange(formData.detail)" />
            <a v-if="disabled && formData.detail.idcardNo" style="position: absolute; color: #2d8cf0 !important">
              <i class="iconfont iconyincang eye-icon eye" v-if="!formData.detail.eyeShowidcardNo" @click="openEye(formData.detail, 'idcardNo')"></i>
            </a>
          </FormItem>
          <FormItem label="身份证头像面" prop="idcardHead1">
            <uploadNew @show="openEye(formData, 'idcardHead1')" v-model="formData.idcardHead1" :disabled="disabled" />
          </FormItem>
          <FormItem label="身份证国徽面" prop="idcardBack1">
            <uploadNew @show="openEye(formData, 'idcardBack1')" v-model="formData.idcardBack1" :disabled="disabled" />
          </FormItem>
          <FormItem label="出生日期" prop="detail.birthday" :rules="$units.formRule.required('请选择')">
            <span v-if="disabled">{{ formData.detail.birthday | cutString(10) }}</span>
            <DatePicker
              v-else
              type="date"
              format="yyyy-MM-dd"
              placeholder="选择日期"
              :editable="false"
              :value="formData.detail.birthday"
              @on-change="$set(formData.detail, 'birthday', $event)"
            ></DatePicker>
          </FormItem>
          <FormItem label="性別" prop="detail.gender" :rules="$units.formRule.required('请选择')">
            <span v-if="disabled">{{ formData.detail.gender == 1 ? '男' : '女' }}</span>
            <RadioGroup v-model="formData.detail.gender" v-else>
              <Radio label="1">男</Radio>
              <Radio label="2">女</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="通行证或护照号码" prop="detail.passportCode">
            <span v-if="disabled" class="descrypt-text" @dblclick="openEye(formData.detail, 'passportCode')">{{ formData.detail.passportCode }}</span>
            <Input v-else v-model="formData.detail.passportCode" placeholder="请输入" />
            <a v-if="disabled && formData.detail.passportCode" style="position: absolute; color: #2d8cf0 !important">
              <i class="iconfont iconyincang eye-icon eye" v-if="!formData.detail.eyeShowpassportCode" @click="openEye(formData.detail, 'passportCode')"></i>
            </a>
          </FormItem>
          <FormItem label="通行证正面" prop="passportHead1">
            <uploadNew @show="openEye(formData, 'passportHead1')" v-model="formData.passportHead1" :disabled="disabled" />
          </FormItem>
          <FormItem label="通行证反面" prop="passportBack1">
            <uploadNew @show="openEye(formData, 'passportBack1')" v-model="formData.passportBack1" :disabled="disabled" />
          </FormItem>
          <FormItem label="身份证地址" prop="detail.idcardAddr" :rules="$units.formRule.required('请输入')">
            <span v-if="disabled" class="descrypt-text" @dblclick="openEye(formData.detail, 'idcardAddr')">{{ formData.detail.idcardAddr }}</span>
            <Input v-else v-model="formData.detail.idcardAddr" placeholder="请输入" type="textarea" :autosize="{ minRows: 2 }" />
            <a v-if="disabled && formData.detail.idcardAddr" style="position: absolute; color: #2d8cf0 !important">
              <i class="iconfont iconyincang eye-icon eye" v-if="!formData.detail.eyeShowidcardAddr" @click="openEye(formData.detail, 'idcardAddr')"></i>
            </a>
          </FormItem>
          <FormItem label="现居住地址" prop="detail.currentAddr" :rules="$units.formRule.required('请输入')">
            <span v-if="disabled" class="descrypt-text" @dblclick="openEye(formData.detail, 'currentAddr')">{{ formData.detail.currentAddr }}</span>
            <Input v-else v-model="formData.detail.currentAddr" placeholder="请输入" type="textarea" :autosize="{ minRows: 2 }" />
            <a v-if="disabled && formData.detail.currentAddr" style="position: absolute; color: #2d8cf0 !important">
              <i class="iconfont iconyincang eye-icon eye" v-if="!formData.detail.eyeShowcurrentAddr" @click="openEye(formData.detail, 'currentAddr')"></i>
            </a>
          </FormItem>

          <div class="form-title">家庭/工作信息</div>
          <FormItem label="婚姻状况" prop="detail.maritalStatus" :rules="$units.formRule.required('请输入')">
            <lzDicTxt v-if="disabled" dicType="MARITAL" :dicCode="formData.detail.maritalStatus" />
            <lzDicSelect v-else v-model="formData.detail.maritalStatus" dicType="MARITAL" :transfer="true" clearable />
          </FormItem>
          <FormItem label="邮编" prop="detail.postalCode" :rules="$units.formRule.num('输入的类型为数字')">
            <span v-if="disabled">{{ formData.detail.postalCode }}</span>
            <Input v-else v-model="formData.detail.postalCode" placeholder="只能填写数字" />
          </FormItem>
          <FormItem
            label="联系电话"
            prop="detail.mobile"
            :rules="formData.detail.mobile && formData.detail.mobile.indexOf('*') != -1 ? {} : $units.formRule.tel()"
          >
            <span v-if="disabled" class="descrypt-text" @dblclick="openEye(formData.detail, 'mobile')">{{ formData.detail.mobile }}</span>
            <Input v-else v-model="formData.detail.mobile" placeholder="请输入" />
            <a v-if="disabled && formData.detail.mobile" style="position: absolute; color: #2d8cf0 !important">
              <i class="iconfont iconyincang eye-icon eye" v-if="!formData.detail.eyeShowmobile" @click="openEye(formData.detail, 'mobile')"></i>
            </a>
          </FormItem>
          <FormItem
            label="电子邮箱"
            prop="detail.email"
            :rules="formData.detail.email && formData.detail.email.indexOf('*') != -1 ? {} : $units.formRule.email()"
          >
            <span v-if="disabled" class="descrypt-text" @dblclick="openEye(formData.detail, 'email')">{{ formData.detail.email }}</span>
            <lzEmailInput v-else v-model="formData.detail.email"></lzEmailInput>
            <a v-if="disabled && formData.detail.email" style="position: absolute; color: #2d8cf0 !important">
              <i class="iconfont iconyincang eye-icon eye" v-if="!formData.detail.eyeShowemail" @click="openEye(formData.detail, 'email')"></i>
            </a>
          </FormItem>
          <FormItem
            :label="formData.detail.occupation * 1 === 1 ? '学校名称' : '公司名称'"
            prop="detail.companyName"
            :rules="formData.detail.occupation * 1 === 1 ? $units.formRule.required('请输入') : { required: false }"
          >
            <span v-if="disabled" class="descrypt-text" @dblclick="openEye(formData.detail, 'companyName')">{{ formData.detail.companyName }}</span>
            <Input v-else v-model="formData.detail.companyName" placeholder="请输入" />
            <a v-if="disabled && formData.detail.companyName" style="position: absolute; color: #2d8cf0 !important">
              <i class="iconfont iconyincang eye-icon eye" v-if="!formData.detail.eyeShowcompanyName" @click="openEye(formData.detail, 'companyName')"></i>
            </a>
          </FormItem>
          <FormItem label="职业" prop="detail.occupation">
            <lzDicTxt v-if="disabled" dicType="OCCUPATION" :dicCode="formData.detail.occupation" />
            <lzDicSelect v-else v-model="formData.detail.occupation" dicType="OCCUPATION" :transfer="true" clearable />
          </FormItem>
          <FormItem label="行业" prop="detail.industry" v-if="formData.detail.occupation != '1'">
            <lzDicTxt v-if="disabled" dicType="INDUSTRY" :dicCode="formData.detail.industry" />
            <lzDicSelect v-else v-model="formData.detail.industry" dicType="INDUSTRY" :transfer="true" clearable> </lzDicSelect>
          </FormItem>
          <FormItem label="年薪（港币）" prop="detail.annualIncome" :rules="$units.formRule.num('输入的类型为数字')">
            <span v-if="disabled">{{ formData.detail.annualIncome }}</span>
            <Input v-else v-model="formData.detail.annualIncome" placeholder="只能填写数字" />
          </FormItem>
          <FormItem label="最高学历" prop="detail.eduLevel" :rules="$units.formRule.required('请选择')">
            <lzDicTxt v-if="disabled" dicType="EDUCATION" :dicCode="formData.detail.eduLevel" />
            <lzDicSelect v-else v-model="formData.detail.eduLevel" dicType="EDUCATION" :transfer="true" clearable> </lzDicSelect>
          </FormItem>
          <FormItem label="开立户口目的" prop="detail.purpose" :rules="$units.formRule.required('请选择')">
            <lzDicTxt v-if="disabled" dicType="BANK_ACC_PURPOSE" :dicCode="formData.detail.purpose" />
            <lzDicSelect v-else v-model="formData.detail.purpose" dicType="BANK_ACC_PURPOSE" :transfer="true" clearable> </lzDicSelect>
          </FormItem>
          <FormItem
            :label="formData.detail.occupation * 1 === 1 ? '学校地址' : '公司地址'"
            prop="detail.companyAddr"
            :rules="formData.detail.occupation * 1 === 1 ? $units.formRule.required('请输入') : { required: false }"
          >
            <span v-if="disabled" class="descrypt-text" @dblclick="openEye(formData.detail, 'companyAddr')">{{ formData.detail.companyAddr }}</span>
            <Input v-else v-model="formData.detail.companyAddr" placeholder="请输入" type="textarea" :autosize="{ minRows: 2 }" />
            <a v-if="disabled && formData.detail.companyAddr" style="position: absolute; color: #2d8cf0 !important">
              <i class="iconfont iconyincang eye-icon eye" v-if="!formData.detail.eyeShowcompanyAddr" @click="openEye(formData.detail, 'companyAddr')"></i>
            </a>
          </FormItem>
          <FormItem label="备注">
            <span v-if="disabled">{{ formData.detail.remark }}</span>
            <Input v-else v-model="formData.detail.remark" placeholder="请输入" type="textarea" :autosize="{ minRows: 2 }" />
          </FormItem>
        </template>
      </template>
    </Form>
    <div class="bottom-btn">
      <Button type="primary" ghost @click="backPage()">返回</Button>
      <Button type="primary" v-if="!disabled" ghost @click="ok()">保存</Button>
      <Button type="primary" v-if="!disabled" @click="ok('submit')">提交</Button>
    </div>
    <validUserName ref="validUserNameRef" @success="(...params) => openEye(...params)" />
  </div>
</template>

<script>
// 引入公共混入
import { common } from '@/api/mixins';
// 引入数据字典选择组件
import lzDicSelect from '@/components/commons/lzDicSelect';
// 引入数据字典文本显示组件
import lzDicTxt from '@/components/commons/lzDicTxt';
// 引入邮箱输入组件
import lzEmailInput from '@/components/commons/lzEmailInput';
// 引入文件上传组件
import uploadNew from '@/components/commons/maskUploadNew';
// 引入下拉选择组件
import lzSelect from '@/components/commons/lzSelect';
// 引入用户名验证组件
import validUserName from '@/components/commons/validUserName';
import _ from 'lodash';
export default {
  mixins: [common],
  components: {
    lzDicSelect,
    lzEmailInput,
    uploadNew,
    lzSelect,
    lzDicTxt,
    validUserName
  },
  props: {},
  data() {
    return {
      id: '', // 订单ID
      svcId: '', // 服务ID
      formData: null, // 表单数据
      serviceInfo: {}, // 服务信息
      disabled: false, // 是否禁用表单
      loading: false // 加载状态
    };
  },
  watch: {},
  computed: {},
  created() {
    this.id = this.$route.query.id;
    this.svcId = this.$route.query.svcId;
    this.disabled = this.$route.query.islook == 1;
    this.getServiceInfo();
    if (this.id) {
      this.getDetail();
      if (this.disabled) {
        this.setPageTitle('订单详情');
      } else {
        this.setPageTitle('编辑订单');
      }
    } else {
      this.setPageTitle('兑换服务');
      this.formData = {
        cType: '1',
        svcId: this.svcId,
        detail: {},
        idcardHead1: [], //身份证头像
        idcardBack1: [], //身份证国徽
        passportHead1: [], // 港澳通行证/护照正面
        passportBack1: [] // 港澳通行证/护照反面
      };
    }
  },
  methods: {
    openEye(row, code) {
      if (!row['validName' + code]) {
        this.$refs.validUserNameRef.open(row, code);
        return;
      }
      if (!row['eyeShow' + code]) {
        let cardType = {
          'idcardHead1': 'idcard_head',
          'idcardBack1': 'idcard_back',
          'passportHead1': 'passport_head',
          'passportBack1': 'passport_back',
          'idcardHead2': 'idcard_head',
          'idcardBack2': 'idcard_back',
          'passportHead2': 'passport_head',
          'passportBack2': 'passport_back'
        };
        let operationType = {
          // 1-证件号解密  2-手机号解密 3-银行卡号 4-邮箱  5-通讯地址   6-身份证地址 7-居住地地址 8-通行证/护照号码 9-公司/学校名称 10-公司/学校地址
          idcardNo: 1,
          mobile: 2,
          email: 4,
          idcardAddr: 6,
          currentAddr: 7,
          passportCode: 8,
          companyName: 9,
          companyAddr: 10,
          customerName: 12,
          namePinyin: 13
        };
        this.descrypt(
          {
            query: this.id ? this.id : this.formData.rid, //没有id 按照预约单解析
            cardType: cardType[code],
            operationType: operationType[code] || 14,
            operationFunction: this.id ? 17 : 14,
            customerType: 1
          },
          row,
          code
        ).then(() => {
          this.$set(row, 'eyeShow' + code, true);
        });
      }
    },
    // 获取服务信息
    getServiceInfo() {
      this.$http({
        url: '/buz/extSvc/detail',
        type: 'GET',
        data: {
          id: this.svcId
        }
      }).then(res => {
        this.serviceInfo = res.data;
      });
    },
    // 通过订单ID获取订单详情信息
    getDetail() {
      this.$http({
        url: '/buz/extSvc/order/detail', // 请求订单详情接口
        type: 'GET',
        data: {
          id: this.id // 传入订单ID参数
        }
      }).then(res => {
        const detail = res.data;
        // 设置客户类型,有rid为签单客户(1),无rid为非签单客户(0)
        detail.cType = detail.rid ? '1' : '0';
        // 初始化detail对象
        detail.detail = detail.detail || {};

        // 处理附件信息
        if (detail.detail.attachment) {
          const arr = detail.detail.attachment;
          // 根据附件类型过滤身份证正反面和护照正反面
          detail.idcardHead1 = arr.filter(item => item.type == 'idcard_head'); // 身份证正面
          detail.idcardBack1 = arr.filter(item => item.type == 'idcard_back'); // 身份证反面
          detail.passportHead1 = arr.filter(item => item.type == 'passport_head'); // 护照正面
          detail.passportBack1 = arr.filter(item => item.type == 'passport_back'); // 护照反面
        } else {
          // 无附件时初始化为空数组
          detail.idcardHead1 = [];
          detail.idcardBack1 = [];
          detail.passportHead1 = [];
          detail.passportBack1 = [];
        }

        // 非查看模式时,根据订单状态设置是否禁用
        // 订单状态为待完成(0)或已驳回(3)时可编辑,其他状态禁用
        if (this.$route.query.islook != 1) {
          this.disabled = ![0, 3].includes(detail.orderState * 1);
        }

        // 将获取的详情数据赋值给表单对象
        this.formData = detail;
      });
    },
    // 预约单号变更事件处理
    reservationNoChange() {
      // 如果没有选择预约单号,直接返回
      if (!this.formData.reservationNo) {
        return;
      }

      // 根据预约单号查找对应的预约单数据
      const data = this.$refs.userSelect.list.find(item => item.reservationNo == this.formData.reservationNo);
      console.log('ridChange', data);

      // 调用接口校验预约单是否可用
      this.$http({
        url: '/buz/extSvc/order/check',
        type: 'GET',
        All: true,
        data: {
          rid: data.rid
        }
      }).then(res => {
        // 校验不通过,清空预约单相关数据
        if (!res.data) {
          this.$notice.error(res.msg);
          this.formData.reservationNo = '';
          this.formData.rid = '';
          return;
        }

        // 校验通过,将预约单数据填充到表单中
        if (data) {
          // 设置基本信息
          this.$set(this.formData, 'customerName', data.name);
          this.$set(this.formData, 'rid', data.rid);

          // 设置个人信息
          this.$set(this.formData.detail, 'namePinyin', data.insurant.personalInfo.namePinyin);
          this.$set(this.formData.detail, 'idcardNo', data.insurant.personalInfo.idcardNo);
          this.$set(this.formData.detail, 'birthday', data.insurant.personalInfo.birthday);
          this.$set(this.formData.detail, 'gender', data.insurant.personalInfo.gender);
          this.$set(this.formData.detail, 'passportCode', data.insurant.personalInfo.passportCode);
          this.$set(this.formData.detail, 'idcardAddr', data.insurant.personalInfo.idcardAddr);
          this.$set(this.formData.detail, 'currentAddr', data.insurant.personalInfo.currentAddr);
          this.$set(this.formData.detail, 'maritalStatus', data.insurant.personalInfo.maritalStatus);
          this.$set(this.formData.detail, 'mobile', data.insurant.personalInfo.mobile);
          this.$set(this.formData.detail, 'email', data.insurant.personalInfo.email);
          this.$set(this.formData.detail, 'eduLevel', data.insurant.personalInfo.eduLevel);
          this.$set(this.formData.detail, 'postalCode', data.insurant.personalInfo.postalCode);

          // 设置工作信息
          this.$set(this.formData.detail, 'companyName', data.insurant.workInfo.company);
          this.$set(this.formData.detail, 'occupation', data.insurant.workInfo.occupation);
          this.$set(this.formData.detail, 'industry', data.insurant.workInfo.industry);
          this.$set(this.formData.detail, 'companyAddr', data.insurant.workInfo.address);

          // 设置附件信息
          if (data.insurant.attachment) {
            const arr = data.insurant.attachment;
            // 设置身份证正反面
            this.$set(
              this.formData,
              'idcardHead1',
              arr.filter(item => item.type == 'idcard_head')
            );
            this.$set(
              this.formData,
              'idcardBack1',
              arr.filter(item => item.type == 'idcard_back')
            );
            // 设置护照正反面
            this.$set(
              this.formData,
              'passportHead1',
              arr.filter(item => item.type == 'passport_head')
            );
            this.$set(
              this.formData,
              'passportBack1',
              arr.filter(item => item.type == 'passport_back')
            );
          } else {
            // 无附件时初始化为空数组
            this.$set(this.formData, 'idcardHead1', []);
            this.$set(this.formData, 'idcardBack1', []);
            this.$set(this.formData, 'passportHead1', []);
            this.$set(this.formData, 'passportBack1', []);
          }
        }
      });
    },
    // 身份证号码变更时自动解析生日和性别
    idcardChange(data) {
      // 获取身份证号码
      const idNo = data.idcardNo;
      // 身份证号码正则校验(15位或18位)
      const pattern = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if (pattern.test(idNo)) {
        // 从身份证号码中解析出生日(格式:YYYY-MM-DD)
        const birthday = idNo.substr(6, 4) + '-' + idNo.substr(10, 2) + '-' + idNo.substr(12, 2);
        // 从身份证号码中解析性别(1-男,2-女)
        const sex = idNo.substr(16, 1) % 2 == 1 ? '1' : '2';
        // 设置生日和性别
        this.$set(data, 'birthday', birthday);
        this.$set(data, 'gender', sex);
      }
    },
    // 查询预约单号
    getOrderList(keyword) {
      if (!keyword) {
        return [];
      }
      const params = {
        keyword
      };
      return this.$http({
        url: '/buz/reservation/customer/search',
        type: 'POST',
        data: params
      }).then(res => {
        return res.data;
      });
    },
    /**
     * 表单提交/保存处理
     * @param {string} type - 操作类型:submit-提交,save-保存
     */
    ok(type) {
      // 提交操作
      if (type == 'submit') {
        // 表单校验
        this.$refs.myForm.validate().then(async isok => {
          if (!isok) {
            // 校验不通过,显示错误提示并滚动到第一个错误项
            this.$notice.error('校验不通过，请完善表单');
            this.$nextTick(() => {
              document.getElementsByClassName('ivu-form-item-error')[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
            });
            return;
          }
          // 调用提交接口
          this.okCallback(type, '/buz/extSvc/order/submit');
        });
      } else {
        // 保存操作
        // 清除校验
        this.clearValidate();
        window.setTimeout(() => {
          // 必填字段校验
          const keyArr = ['customerName'];
          let hasError = false;
          keyArr.forEach(key => {
            this.$refs.myForm.validateField(key, errorMsg => {
              if (errorMsg) {
                hasError = true;
              }
            });
          });

          // 非必填字段格式校验(手机号、邮箱、邮编、年收入)
          const keyArr2 = ['detail.mobile', 'detail.email', 'detail.postalCode', 'detail.annualIncome'];
          keyArr2.forEach(key => {
            if (_.get(this.formData, key)) {
              this.$refs.myForm.validateField(key, errorMsg => {
                if (errorMsg) {
                  hasError = true;
                }
              });
            }
          });

          // 校验不通过处理
          if (hasError) {
            this.$notice.error('校验不通过，请完善表单');
            this.$nextTick(() => {
              document.getElementsByClassName('ivu-form-item-error')[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
            });
            return;
          }

          // 调用保存接口
          this.okCallback(type, '/buz/extSvc/order/save');
        }, 100);
      }
    },
    // 提交回调
    okCallback(type, url) {
      const formData = JSON.parse(JSON.stringify(this.formData));
      // 处理附件
      formData.detail.attachment = [];
      this.addKey(formData.detail.attachment, formData, 'idcardHead1', 'idcard_head');
      this.addKey(formData.detail.attachment, formData, 'idcardBack1', 'idcard_back');
      this.addKey(formData.detail.attachment, formData, 'passportHead1', 'passport_head');
      this.addKey(formData.detail.attachment, formData, 'passportBack1', 'passport_back');
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.$http({
        url: url,
        type: 'post',
        data: formData
      })
        .then(res => {
          this.$notice.success('提交成功');
          this.visible = false;
          if (!this.formData.id) {
            this.id = res.data;
          }
          this.getDetail();
        })
        .finally(res => {
          window.setTimeout(() => {
            this.loading = false;
          }, 300);
        });
    },
    // 添加附件类型并保存到列表中
    // saveList: 保存附件的列表
    // data: 表单数据
    // key: 附件字段名
    // type: 附件类型(idcard_head/idcard_back/passport_head/passport_back)
    addKey(saveList, data, key, type) {
      data[key].forEach(item => {
        item.type = type; // 设置附件类型
        saveList.push(item); // 添加到保存列表
      });
      delete data[key]; // 删除原字段
    },
    // 返回
    backPage() {
      this.back(this.$route.query.backUrl);
    }
  }
};
</script>
<style lang="scss" scoped>
.main-container {
  padding-bottom: 100px;
}
.info-box {
  background: linear-gradient(106deg, #fff7ea 0%, #fff1e8 100%);
  padding: 12px 24px;
  margin-bottom: 15px;
}
.bottom-btn {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 70px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid #ccc;
  .ivu-btn {
    width: 140px;
    height: 35px;
  }
  .ivu-btn + .ivu-btn {
    margin-left: 20px;
  }
}
.pie {
  white-space: pre-line;
}
</style>
